import { z } from 'zod';
import { LABELS } from '../../constants';
import { requiredFieldError, requiredString, validateMobileAndPhone } from '../../helper';
import { EnterpriseStructure } from '../../types';
import { enterpriseIdentification } from './ownershipDetail';

const { OWNERSHIP_PERCENTAGE, EMAIL_ADDRESS, PHONE_NUMBER } = LABELS;

const beneficialOwnerItem = z
  .object({
    ownershipPercentage: z
      .number({
        required_error: requiredFieldError(OWNERSHIP_PERCENTAGE),
        invalid_type_error: requiredFieldError(OWNERSHIP_PERCENTAGE),
      })
      .min(10, `${OWNERSHIP_PERCENTAGE} should be 10% or more`)
      .max(100, `${OWNERSHIP_PERCENTAGE} should be less than or equal to 100%`),
    email: requiredString(EMAIL_ADDRESS).email(),
    phone: requiredString(PHONE_NUMBER).pipe(validateMobileAndPhone),
  })
  .and(enterpriseIdentification);

const requiredBeneficialOwners = z.array(beneficialOwnerItem).min(1, requiredFieldError('Number of beneficial owners'));

export const proprietaryLimitedCompanyBeneficialOwners = z.object({
  structure: z.literal(EnterpriseStructure.ProprietaryLimitedCompany),
  proprietaryLimitedCompany: z.object({
    beneficialOwners: requiredBeneficialOwners,
  }),
});

export const partnershipBeneficialOwners = z.object({
  structure: z.literal(EnterpriseStructure.Partnership),
  partnership: z.object({
    beneficialOwners: requiredBeneficialOwners,
  }),
});

export const trustBeneficialOwners = z.object({
  structure: z.literal(EnterpriseStructure.Trust),
  trust: z.object({
    beneficialOwners: requiredBeneficialOwners,
  }),
});

export const beneficialOwnersSchema = z.discriminatedUnion('structure', [
  proprietaryLimitedCompanyBeneficialOwners,
  partnershipBeneficialOwners,
  trustBeneficialOwners,
]);
